export const parseCameraError = (error: string) => {
  switch (error) {
    case 'NotAllowedError: Permission denied':
      return 'カメラの起動権限がありません';
    case 'NotReadableError: Device in use':
      return '他のアプリケーションでカメラを使用中です';
    default:
      return error;
  }
};
